import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateSiteInput, SiteSummary, VerifyResult, VerifySiteInput } from '@ametica/shared';
import { api } from './client';

export const SITES_KEY = ['sites'] as const;

export function useSites() {
  return useQuery({ queryKey: SITES_KEY, queryFn: () => api<SiteSummary[]>('/sites') });
}

export function useSite(id: string) {
  return useQuery({ queryKey: [...SITES_KEY, id], queryFn: () => api<SiteSummary>(`/sites/${id}`) });
}

/** Nový token na skopírovanie — server ho NEukladá, uloží ho až vytvorenie stránky. */
export function useNewSiteToken(enabled: boolean) {
  return useQuery({
    queryKey: [...SITES_KEY, 'new-token'],
    queryFn: () => api<{ token: string; wpConfigLine: string }>('/sites/new-token'),
    enabled,
    staleTime: Infinity,
    gcTime: 0,
  });
}

export function useVerifySite() {
  return useMutation({
    mutationFn: (input: VerifySiteInput) => api<VerifyResult>('/sites/verify', { method: 'POST', body: JSON.stringify(input) }),
  });
}

export function useCreateSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateSiteInput) => api<SiteSummary>('/sites', { method: 'POST', body: JSON.stringify(input) }),
    onSuccess: () => qc.invalidateQueries({ queryKey: SITES_KEY }),
  });
}

export function useDeleteSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api<void>(`/sites/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: SITES_KEY }),
  });
}
